<script>
export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    voucherAmount: Number,
    voucherCode: String,
    voucherURL: String,
  },
  data() {
    return {
      voucherAmountToPrint: null,
      voucherCodeToPrint: null,
      voucherURLToDownload: null,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    this.voucherAmountToPrint = this.voucherAmount;
    this.voucherCodeToPrint = this.voucherCode;
    this.voucherURLToDownload = this.voucherURL;
  },
  methods: {
    clickCloseButton() {
      this.$emit("reload");
    },
  },
};
</script>

<template>
  <!-- Delete Dataset Model -->
  <b-modal
    v-model="showModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    header-close-content
    size="lg"
  >
    <div class="row mt-3">
      <div class="col-md-12 text-lg-center imageContainer">
        <b-img
          class=""
          alt=""
          :src="require('@/assets/images/Voucher Image.jpg')"
          style="width: 100%"
        ></b-img>
        <h1 class="voucherAmount">{{ this.voucherAmountToPrint }}</h1>
        <h3 class="voucherCode">{{ this.voucherCodeToPrint }}</h3>
      </div>
      <div class="col-md-12 text-lg-center mt-5">
        <div class="pb-2">
          <a :href="voucherURLToDownload" target="_blank">
            <b-button class="mr-2" variant="success"
              ><i class="fa fa-print mr-2"></i
              >{{ $t("vouchers.generate.printButton") }}</b-button
            >
          </a>
          <b-button variant="light" @click="clickCloseButton()">{{
            $t("general.buttons.cancel")
          }}</b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.imageContainer {
  position: relative;
  text-align: center;
  color: #02141f;
}
.voucherAmount {
  position: absolute;
  top: 133px;
  left: 8%;
  color: #bead8e;
  font-size: 50px;
  font-weight: 600;
  font-family: poppins;
}
.voucherCode {
  position: absolute;
  bottom: 25px;
  left: 62px;
  color: #02141f;
}
</style>